<h2 mat-dialog-title>Edit Sku</h2>
<mat-dialog-content>
  <div class="modal-inputs">
    <mat-form-field appearance="fill">
      <mat-label>Name</mat-label>
      <input matInput #skuNameInput [value]="data.sku_name" disabled />
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Description</mat-label>
      <input matInput #descriptionInput [value]="data.description" />
    </mat-form-field>

    <mat-slide-toggle
      #enabledInput
      class="mat-accent"
      [checked]="toBoolean(data.enabled)"
      >Enabled</mat-slide-toggle
    >

    <mat-form-field appearance="fill">
      <mat-label>Solutions</mat-label>
      <mat-select #solutionsSelect multiple [(ngModel)]="data.solutions">
        <mat-option value="BOBA">BOBA</mat-option>
        <mat-option value="DPC">DPC</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="modal-btn-group">
    <button mat-button mat-dialog-close color="primary" class="secondary-btn mr-15 mb-15">Cancel</button>
    <button
      mat-flat-button
      cdkFocusInitial
      color="primary"
      class="primary-btn mr-15 mb-15"
      (click)="updateSku()"
    >
      Update Sku
    </button>
  </div>
</mat-dialog-actions>
